import React from 'react';
import Translate from '../../../components/Translate/Translate';
import JobOfferBanner from './JobOfferBanner';
import JobOfferBoxes from './JobOfferBoxes';
import JobOfferImages from './JobOfferImages';
import JobOffersCarousel from './JobOffersCarousel';
import JobOffersSection from './JobOffersSection';
import JobOfferVideo from './JobOfferVideo';
import './styles/index.scss';

const JobOffersPage = () => {
  return (
    <div className="component-jobOffersPage">
      <JobOfferVideo />
      <JobOfferBoxes />
      <div className="text-center max-w-3xl mx-auto my-20 lg:my-28">
        <h2 className="text-4xl leading-12 mb-4 font-axi-bold lg:text-5xl lg:leading-16">
          <Translate component="jobOffers" keyword="title" />
        </h2>
        <p className="text-base leading-6 lg:text-lg lg:leading-7">
          <Translate component="jobOffers" keyword="sub-title" />
        </p>
      </div>
      <JobOfferImages />
      <JobOffersSection />
      <JobOfferBanner />
      <JobOffersCarousel />
    </div>
  );
};

export default JobOffersPage;
